module.exports = new __parcel__URL__("tony-hawks-pro-skater-2.8ed69573.jpg").toString();